import { render } from "./Video.vue?vue&type=template&id=a5e8b040"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"

import "./Video.vue?vue&type=style&index=0&id=a5e8b040&lang=css"
script.render = render

export default script